import { IAggregateStoreDefinitionInfo, ICustomViewFilterSettings, queryAggregateStoreInfo } from "c8-platform";
import Controller from "csi/action/Controller";
import { loadDataStoreFilterMapAndPopulateAdditionalQuery } from "csi/middleware/customView/customViewService";
import localeProvider from "csi/page/localeProvider";
import { getSubtypeName } from "csi/reflection/reflection";
import { routerStore } from "csi/state/rootStore";
import { pathCreate } from "csi/utility/pathUtility";
import declare from "dojo/_base/declare";
import { AggregateStoreInfoStore } from "src/SiteAdmin/AggregateStore/AggregateStoreInfoStore";
import AggregateStoreDialog from "./AggregateStoreDialog";

const AggregateStoreInfoController = declare(Controller, {
	/**
	 * @override
	 * Ensure access to DependsOn attribute
	 */
	onDependencyPaths(paths: string[]): void {
		paths.push(pathCreate("DependsOn"));
	},

	/**
	 * @override
	 * Open dialog to manage aggregate store
	 */
	async preProcess(): Promise<void> {
		const {
			DependsOn,
			ReflectionAttributeId,
			ReflectionAttributeOwner,
			"Value Type": ValueType,
			TargetClassName,
			Subtype,
		} = this.getNode();

		const dependsOnId = this.m_cache.get(DependsOn)?.ReflectionAttributeId;
		const subtype = getSubtypeName(Subtype);
		let dataStoreFilterMap: Record<string, ICustomViewFilterSettings>;
		let result: IAggregateStoreDefinitionInfo;

		try {
			result = await queryAggregateStoreInfo(ReflectionAttributeOwner, ReflectionAttributeId, ValueType, TargetClassName, subtype, dependsOnId);
			dataStoreFilterMap = await loadDataStoreFilterMapAndPopulateAdditionalQuery(result);
		} catch (ex) {
			// aggregate store must not exist, so initialize empty object
			result = {
				sourceClass: ReflectionAttributeOwner,
				targetClass: TargetClassName,
			};
		}

		// create the aggregate store info store and open dialog
		const store = new AggregateStoreInfoStore(ReflectionAttributeId, result, localeProvider, dataStoreFilterMap);

		this.useReactDialog(routerStore.openDialog(AggregateStoreDialog, {
			onClose: () => {
				this.onCancelReactDialog();
			},
			onSave: () => {
				if (store.validate()) {
					store.writeOperations(this.m_writer, ReflectionAttributeId);
					this.processReact();
				}
			},
			title: this.getTitle(),
			store,
		}));
	},

});

export = AggregateStoreInfoController;
